import React from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header>
      <Navbar bg="light" expand="lg">
        <Container>
            <Navbar.Brand as={Link} to={'/'}>
            Blog
            </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
            <Nav.Link as={Link} to={'/'}>Home</Nav.Link>
              <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                <NavDropdown.Item
                  target="_blank"
                  href="https://github.com/minsoo0715"
                >
                  Github
                </NavDropdown.Item>
                <NavDropdown.Item
                  target="_blank"
                  href="https://twitter.com/_WhiteBlock_"
                >
                  Twitter
                </NavDropdown.Item>
                <NavDropdown.Item
                  target="_blank"
                  href="https://blog.naver.com/minsoo0715"
                >
                  Naver Blog
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => {
                    navigator.clipboard.writeText("minsoo0715@hanyang.ac.kr");
                  }}
                >
                  Email (click to copy)
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
